import { FC } from 'react';
import {
  ConnectBalances,
  ConnectComponentsProvider,
  ConnectPayments,
} from '@stripe/react-connect-js';

import { MerchantOnboardingStatus } from '__generated__/GQL';

import { MerchantAccount } from '../../hooks/useMerchantPageQuery';
import { useStripeConnect } from '../../hooks/useStripeConnect';

interface MerchantDahsboardProps {
  merchantAccount: MerchantAccount;
}

export const MerchantDahsboard: FC<MerchantDahsboardProps> = ({
  merchantAccount,
}) => {
  const { stripeConnectInstance } = useStripeConnect();

  if (merchantAccount.onboardingStatus !== MerchantOnboardingStatus.Complete) {
    return <div>???</div>;
  }

  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectBalances />
      <ConnectPayments />
    </ConnectComponentsProvider>
  );
};
